// @ts-nocheck
import React from 'react';

import { Switch } from 'antd';
import './OpportunitySwitch.sass';
import { useTranslation } from 'react-i18next';

const width = document.body.offsetWidth;

export const OpportunitySwitch = (props: any) => {
	const [score, setScore] = React.useState<any | null>(0);
	const { t } = useTranslation();
	return (
		<div>

			{t('models.risk.name')}
			<Switch
				{...props}
				className={"OpportunitySwitch " + (props.className || "")}
			/>
			{t('models.risk.name_positive')}
		</div>
	);
};
